document
  .querySelectorAll(".claimed-percentage-container[data-product-id]")
  .forEach((el) => {
    getPercentageClaimed(el);
  });
function getPercentageClaimed(parentEl) {
  console.log(parentEl);
  let progressBar = parentEl.querySelector(".claimed-percentage-progress-bar");
  let percentageText = parentEl.querySelector(".claimed-percentage-text");
  let initialPercentage = parseFloat(
    parentEl.getAttribute("data-initial-percentage-value")
  );
  let targetPercentage = 99;
  let now = new Date();
  let estNow = new Date(
    now.toLocaleString("en-US", { timeZone: "America/New_York" })
  );
  let startTime = new Date(estNow);
  startTime.setHours(0, 0, 0, 0);
  let targetTime = new Date(estNow);
  targetTime.setHours(20, 0, 0, 0);
  let totalMinutes = (targetTime - startTime) / (1000 * 60);
  let elapsedMinutes = (estNow - startTime) / (1000 * 60);
  let incrementRate = (targetPercentage - initialPercentage) / totalMinutes;
  let currentPercentage = Math.min(
    initialPercentage + elapsedMinutes * incrementRate,
    targetPercentage
  ).toFixed(0);
  if (currentPercentage >= 99) {
    currentPercentage = 99;
  }
  if (progressBar) {
    progressBar.style.width = `${currentPercentage}%`;
  }
  let cpText = parentEl.getAttribute("data-initial-text");
  if (percentageText) {
    percentageText.textContent = cpText.replace("number", currentPercentage);
  }
  if (document.querySelector(".custom-presale-box-number")) {
    document.querySelector(
      ".custom-presale-box-number"
    ).innerHTML = `${currentPercentage}% Sold`;
  }
}
